import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M172 36.3511C172 32.8435 169.135 30 165.6 30H98.4C94.8654 30 92 32.8435 92 36.3511V61.7554C92 65.263 94.8654 68.1064 98.4 68.1064H117.36C119.1 68.1064 120.765 68.8095 121.972 70.0538L127.788 76.0526C130.306 78.6491 134.494 78.6491 137.012 76.0526L142.828 70.0538C144.035 68.8095 145.7 68.1064 147.44 68.1064H165.6C169.135 68.1064 172 65.263 172 61.7554V36.3511Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "Union"
    }, null, -1),
    _createElementVNode("rect", {
      x: "112",
      y: "46",
      width: "40",
      height: "8",
      rx: "4",
      fill: "var(--dt-color-foreground-primary-inverted)",
      id: "Rectangle 492"
    }, null, -1)
  ]))]))
}
export default { render: render }